"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OutsideAlerter = _interopRequireDefault(require("../molecules/OutsideAlerter"));
var _jsxRuntime = require("react/jsx-runtime");
var ChildrenWrapper = _styledComponents.default.div.withConfig({
  displayName: "ComponentWithNestedContextMenu__ChildrenWrapper",
  componentId: "sc-1u5v8r0-0"
})([""]);
var ComponentWithNestedContextMenu = function ComponentWithNestedContextMenu(_ref) {
  var children = _ref.children,
    NestedContextMenu = _ref.NestedContextMenu;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    showContextMenu = _ref3[0],
    setShowContextMenu = _ref3[1];
  var closeContextMenu = function closeContextMenu() {
    return setShowContextMenu(false);
  };
  var toggleContextMenu = function toggleContextMenu() {
    return setShowContextMenu(!showContextMenu);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OutsideAlerter.default, {
    callback: closeContextMenu,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChildrenWrapper, {
      onClick: toggleContextMenu,
      children: children
    }), showContextMenu && /*#__PURE__*/(0, _jsxRuntime.jsx)(NestedContextMenu, {})]
  });
};
ComponentWithNestedContextMenu.defaultProps = {};
var _default = exports.default = ComponentWithNestedContextMenu;